export const START_POLLING_FOR_QUERY = 'START_POLLING_FOR_QUERY';
export const STOP_POLLING_FOR_QUERY = 'STOP_POLLING_FOR_QUERY';

export const startPollingForQueryStatus = ({ uuid, endpoint, params }) => ({
  type: START_POLLING_FOR_QUERY,
  payload: { uuid, endpoint, params },
});

export const stopPollingForQueryStatus = uuid => ({
  type: STOP_POLLING_FOR_QUERY,
  payload: { uuid },
});
